import { useLocalObservable } from 'mobx-react-lite';

export const useDialog = () =>
  useLocalObservable(() => ({
    show: false,
    onClose() {
      this.show = false;
    },
    onOpen() {
      this.show = true;
    }
  }));
